import React from 'react';
import { TwitterIcon, LinkedinIcon, GithubIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-50 pt-20 pb-10 border-t border-slate-200" data-id="element-69" data-mp="3gfitaf6445cj">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-70" data-mp="32o4deh7i4k9p">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-71" data-mp="32lrk57wamnhc">
          <div className="col-span-1 md:col-span-1" data-id="element-72" data-mp="36q92r3qx2uqj">
            <div className="flex items-center space-x-2 mb-6" data-id="element-73" data-mp="3uf0lz5mj42r6">
              <div className="w-6 h-6 overflow-hidden flex items-center justify-center" data-id="element-74" data-mp="3uftm3nqzfu0c">
                <img src="https://cdn.magicpatterns.com/uploads/hRxQvVCJnxZUvLiFBQfhZy/Kinase_logo_—_transparent,_cropped.png" alt="Kinase Icon" className="h-full w-auto object-cover object-left" style={{
                filter: 'brightness(0) saturate(100%) invert(55%) sepia(60%) saturate(500%) hue-rotate(130deg) brightness(95%) contrast(90%)'
              }} data-id="element-75" data-mp="387ejk1577e7" />
              </div>
              <div className="flex items-baseline gap-2" data-id="element-76" data-mp="3la272nvdqrs2">
                <span className="text-xl font-bold text-slate-900 tracking-tight leading-none" data-id="element-77" data-mp="3gaz7hiy65drh">
                  Kinase
                </span>
                <span className="text-[10px] text-slate-400 font-normal italic tracking-wide" data-id="element-78" data-mp="3v91b1t579z8q">
                  (ky · nase)
                </span>
              </div>
            </div>
            <p className="text-slate-600 text-sm leading-relaxed mb-6" data-id="element-79" data-mp="81pdrea6qp79">
              Sales intelligence infrastructure. Automatically extract
              qualification data and sync to HubSpot.
            </p>
            <div className="flex space-x-4" data-id="element-80" data-mp="hs1xx5e38gcv">
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-81" data-mp="ct75dbqbjdfk">
                <TwitterIcon className="w-5 h-5" data-id="element-82" data-mp="qu1fpzwxfogv" />
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-83" data-mp="mspmzliran4g">
                <LinkedinIcon className="w-5 h-5" data-id="element-84" data-mp="twxuvjrohse2" />
              </a>
              <a href="#" className="text-slate-400 hover:text-slate-900 transition-colors" data-id="element-85" data-mp="yv94puhz42wa">
                <GithubIcon className="w-5 h-5" data-id="element-86" data-mp="13r7of4scwwqd" />
              </a>
            </div>
          </div>

          <div data-id="element-87" data-mp="18m3s526yh8jb">
            <h4 className="text-slate-900 font-medium mb-4" data-id="element-88" data-mp="1clmabq7e75ig">Product</h4>
            <ul className="space-y-3" data-id="element-89" data-mp="1clcma85wr8fe">
              <li data-id="element-90" data-mp="1hkfhl0w360a6">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-91" data-mp="1hjw53zp7g43j">
                  Features
                </a>
              </li>
              <li data-id="element-92" data-mp="1rid15b3038wg">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-93" data-mp="1rgsiaiq1teef">
                  Integrations
                </a>
              </li>
              <li data-id="element-94" data-mp="2af3upvql3dm9">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-95" data-mp="2afn76wxgt9sw">
                  Pricing
                </a>
              </li>
              <li data-id="element-96" data-mp="21nlczgdzopr2">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-97" data-mp="21n1u9xgilxbz">
                  Changelog
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-98" data-mp="2pbuw2ajtizei">
            <h4 className="text-slate-900 font-medium mb-4" data-id="element-99" data-mp="2pdfq7z280gbu">Company</h4>
            <ul className="space-y-3" data-id="element-100" data-mp="2kd1fuad5cuan">
              <li data-id="element-101" data-mp="2kc05y97vadui">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-102" data-mp="2kbgn8qae7lff">
                  About
                </a>
              </li>
              <li data-id="element-103" data-mp="18vrzhwpbeidk">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-104" data-mp="13zbbr3m12610">
                  Blog
                </a>
              </li>
              <li data-id="element-105" data-mp="2wmpoggs3pqjn">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-106" data-mp="2wn96dxhr4exo">
                  Careers
                </a>
              </li>
              <li data-id="element-107" data-mp="2nue4ndrht1cn">
                <a href="#" className="text-slate-600 hover:text-slate-900 text-sm transition-colors" data-id="element-108" data-mp="3bjqk2vdey5ne">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-109" data-mp="31kr7j1pj1pv4">
            <h4 className="text-slate-900 font-medium mb-4" data-id="element-110" data-mp="31larenyqmobs">Stay updated</h4>
            <p className="text-slate-600 text-sm mb-4" data-id="element-111" data-mp="36jkk8rwzpcu8">
              Get the latest updates on product features and releases.
            </p>
            <form className="flex" data-id="element-112" data-mp="1q8qgth93rrcq">
              <input type="email" placeholder="Enter your email" className="bg-white border border-slate-300 rounded-lg px-4 py-2.5 text-sm text-slate-900 placeholder-slate-400 flex-1 focus:outline-none focus:ring-2 focus:ring-teal-500/50 shadow-sm" data-id="element-113" data-mp="1v5qn9t9v6w4d" />
              <button className="bg-teal-500 hover:bg-teal-400 text-white px-4 py-2.5 rounded-lg text-sm font-medium ml-2 transition-colors shadow-sm shadow-teal-500/20" data-id="element-114" data-mp="1wlkxr68cnguv">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between" data-id="element-115" data-mp="zwn2zo0lnixp">
          <p className="text-slate-500 text-sm mb-4 md:mb-0" data-id="element-116" data-mp="1dob99ao63d6r">
            © {new Date().getFullYear()} Kinase AI Inc. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-117" data-mp="18uynr9esbmi8">
            <a href="#" className="text-slate-500 hover:text-slate-900 text-sm transition-colors" data-id="element-118" data-mp="l6ywm8dk9u34">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-slate-900 text-sm transition-colors" data-id="element-119" data-mp="2gawz3rxoby70">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}